module.exports = "dist/605ed7926cf39a2ad5ec2d1f9d391d3d.ttf";